import { useEffect } from "react";
import { useLoadingStore } from "@/features/loading/stores/useLoadingStore";
import { useSelector } from "@xstate/react";
import { load } from "./load.utils";
import type { useMachineProps } from "../types";

export function Load(props: useMachineProps) {
  const resources = useLoadingStore((s) => s.items);
  const reset = useLoadingStore((s) => s.reset)
  const criticalResources = useSelector(
    props.actorRef,
    (s) => s.context.criticalResources
  ) as Set<string> | null;

  // logic
  useEffect(() => {
    if (!props.state.matches("loading") || !resources || !criticalResources) return;

   // debugger
    const criticalKeys = Array.from(criticalResources);
    const { isLoading, isError, isSuccess } = load(resources, criticalKeys);

    if (isError)
    {
      /** React batches them → 1 re-render total. */
      if (props.state.matches("loading")) {
        reset();                              // clear the cache keys
        props.reboot((prev) => prev + 1);     // reboot entire experience
        props.send({ type: "RETRY" });        // add retry in the state machine
      }
    }

    if (isLoading) return;

    if (isSuccess)
    {
      if (props.state.matches("loading")) {
        props.send({ type: "LOAD" });
      }
    }

  }, [props, reset, resources, criticalResources]);

  return null; 
}
